import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import AddDeptModal from "../components/addDeptModal";
import EditDeptModal from "../components/editDeptModal";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const DepartmentMasterView = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [formData, setFormData] = useState({ deptNo: "" });
  const [formData, setFormData] = useState({ branch: "", deptNo: "", deptName: "", user: "" });

          /////////////////////////////////////////////////////////////     
          //✅ Permission checks (safe even if perms not yet loaded; will be false)
          const canView  = hasPermission("Department", "view");
          const canEntry = hasPermission("Department", "entry");
          const canEdit = hasPermission("Department", "edit");
          const canDel = hasPermission("Department", "del");
          /////////////////////////////////////////////////////////////
     



  useEffect(() => {
    fetchData();
  }, [branch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/dept_list?branch=${branch}`);
      setData(response.data.deptList);
      setFilteredData(response.data.deptList);
    } catch (error) {
      console.error("Error fetching deptList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.departmentmaster_name || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };


const handleDelete = async (id) => {
  try {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    });

    Swal.fire({
                title: "Submitting...",
                text: "Please wait while we process your request.",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

    if (result.isConfirmed) {
      await axios.delete(`https://rfs2.infraconsoft.net.in/api/dept_delete/${id}`);

      setData((prevData) =>
        prevData.filter((item) => item.departmentmaster_code !== id)
      );

      setFilteredData((prevFilteredData) =>
        prevFilteredData.filter((item) => item.departmentmaster_code !== id)
      );

      Swal.fire({
        title: "Deleted!",
        text: "Your record has been deleted.",
        icon: "success"
      });
    }
  } catch (error) {
    console.error("Error deleting department:", error);
    Swal.fire({
      title: "Error!",
      text: "Failed to delete department.",
      icon: "error"
    });
  }
};


useEffect(() => {
    const fetchPoNo = async () => {
      try {

        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/dept_addNo`);
        if (response.data.newDeptNo) {
          setFormData((prevState) => ({
            ...prevState,
            dptNo: response.data.newDeptNo,
            user: formData.user,
            branch : formData.branch
          }));
  
          console.log("Fetched Department Number:", response.data.newDeptNo);
        }
      } catch (error) {
        console.error("Error fetching Department Number:", error);
      }
    };
    fetchPoNo();
  }, []);
  
  const openAddModal = () => {
    // console.log("Opening Edit Modal PoNumber:", formData.dptNo);
    setIsAddModalOpen(true);
  };

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editFormData, setEditFormData] = useState({ deptCode: "", deptName: "" });
    
    const openEditModal = (item) => {
        setEditFormData({ deptCode: item.departmentmaster_code, deptName: item.departmentmaster_name });
        setIsEditModalOpen(true);
    };
    
    const closeEditModal = () => {
        setIsEditModalOpen(false);
    };
  

    if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);



  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Department Master</h2>
          <Time />
        </section>



        {/* Add New Button */}
        {canEntry && (
        <div className="add-new-container">
        <button className="add-new-btn" onClick={() => openAddModal()}>
              <i className="fa-solid fa-plus" ></i> Add New
            </button>
        </div>
        )}

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Dept Name"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch</th>
                <th>Department Name</th>
                {canEdit && (
                <th>Modify</th>
                )}
                {canDel && (
                <th>Delete</th>
                )}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.branchCode}</td>
                    <td>{item.departmentmaster_name}</td>
                    {canEdit && (
                    <td onClick={() => openEditModal(item)} style={{color : "#030d68", fontWeight: "bold", cursor: "pointer"}}>Modify</td>
                    )}
                    {canDel && (
                    <td className="del">
                      <i className="fa-solid fa-trash-can " onClick={() => handleDelete(item.departmentmaster_code)}></i>
                    </td>
                    )}
                    
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>

          {/* Always show first page */}
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
          </button>

          {/* Show up to 3 pages dynamically */}
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }

          {/* Next button */}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
          </button>
        </div>
      </div>
      <AddDeptModal isAddOpen={isAddModalOpen} onAddClose={closeAddModal} formData={formData}  setFormData={setFormData} fetchData={fetchData} user={user} branch={branch}/>
      <EditDeptModal
    isOpen={isEditModalOpen}
    onClose={closeEditModal}
    editFormData={editFormData}
    setEditFormData={setEditFormData}
    fetchData={fetchData} branch={branch}
/>
    </div>
  );
};

export default DepartmentMasterView;
